import type { FaireProductEntity } from "../../entity_types/product";

export const p_hnfmpw2q3y: FaireProductEntity = {
  token: "p_hnfmpw2q3y",
  type: "product",
  name: "Me & The Bees Classic Lemonade - 12 Pack",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/94e913e6a5a90e3cef3080c0db6cd496119806091fe9a21587e48d57546b05fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/46bb4e8a53f8d8306c2b271aeb671a5466cc860c9d091ea5f07033c77ae10318.jpeg",
    "https://cdn.faire.com/fastly/123f6624b37496914a68e844f9bd263a69b7c65fd1191049d41639fb07a27e77.jpeg",
  ],
  priceDollars: 57.89,
  description:
    "\n\nSavor the refreshing taste of classic lemonade with this delightful case of 12 bottles, each containing 12 fluid ounces of pure, thirst-quenching goodness. Perfect for picnics, parties, or simply enjoying at home, this lemonade is a must-have for any beverage enthusiast looking for a naturally sweet option. \n\n * Each bottle contains 12 fluid ounces of classic lemonade \n * Packaged in a convenient case of 12 \n * Ideal for gatherings, events, or personal enjoyment \n * Made with real, natural ingredients \n * Perfect balance of sweetness and tartness \nIndulge in the harmonious blend of sweetness and citrus tang, crafted to perfection for any occasion.\n",
  tags: [],
  msrpDollars: 115.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:37.457Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
